module.exports = __webpack_public_path__ + "static/media/tp1.a266a6fd.jpg";